import api from "./api";
import { CategoryType } from "../components/Category/CategoryType";
export type DeletCategoryDto = {
  id: number | string;
};

export const getCategory = async () => {
  return await api.get("/categories/dropdown");
};
export const deleteCategory = async (dto: DeletCategoryDto) => {
  return await api.delete(`/categories/${dto.id}`);
};

export const getCategoryById = async (categoriesId: string | undefined) => {
  return await api.get(`/categories/${categoriesId}`);
};

export const createCategory = async (categoriesDetails: CategoryType) => {
  return await api.post("/categories", categoriesDetails);
};
export const editCategory = async (categoriesId: any, body: CategoryType) => {
  return await api.put(`/categories/${categoriesId}`, body);
};

export const getCategoryApi = async (body: { limit: number; q: string; isActive?: boolean }) => {
  let url = `/categories?limit=${body.limit}&q=${body.q}`;

  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }

  return await api.get(url);
};
/*Category Dropdown */
export const getCategoryDrpdown = async () => {
  return await api.get("/categories/dropdown");
};